import { render, staticRenderFns } from "./VControl.vue?vue&type=template&id=037c7dec&"
import script from "./VControl.vue?vue&type=script&lang=js&"
export * from "./VControl.vue?vue&type=script&lang=js&"
import style0 from "./VControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports